// Renders a `table` event: rows that came straight from the tool, out-of-band from the model (see
// app/tools/dataset.py — anything above `inline_row_limit` rows skips the model entirely). Row count can
// be in the hundreds, so this renders once via a plain <table> rather than any per-cell virtualization;
// the scroll container (.table-box, max-height + overflow:auto) keeps the page itself from growing.
import CopyButton, { tableText } from "./CopyButton";

export default function TableWidget({ spec }) {
  const columns = spec.columns || [];
  const rows = spec.rows || [];
  const matched = spec.matched_rows ?? spec.matchedRows ?? rows.length;

  return (
    <div className="table-card">
      <div className="table-cap">
        <span>{spec.title || "Results"}</span>
        <span className="n">
          {rows.length === matched
            ? `${rows.length.toLocaleString()} rows`
            : `${rows.length.toLocaleString()} of ${matched.toLocaleString()} rows`}
        </span>
        <CopyButton title="Copy table (pastes into Excel)" getText={() => tableText(columns, rows)} />
      </div>
      <div className="table-box">
        <table>
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {columns.map((c) => (
                  <td key={c}>{row[c] === null || row[c] === undefined ? "" : String(row[c])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
